export const STORE_LIVE_PARKING_AVAILABILITIES = 'STORE_LIVE_PARKING_AVAILABILITIES'

export function liveParkingAvailabilitiesReducer (state = [], action) {
    switch (action.type){
        case STORE_LIVE_PARKING_AVAILABILITIES:
            return action.payload
        default: return state
    }
}